var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer difcac mrTop10"},[_c('div',{staticClass:"footer_warp difcac"},[_c('div',{staticClass:"fs14 colfff"},[_vm._v("copy 2021 - 2022")])])])
}]

export { render, staticRenderFns }